import { CHECK_EMAIL_HAS_ERRORED, CHECK_EMAIL_SUCCESS } from './types';
import {
  VERIFICATION_ACCESS_KEY,
  FEED_URLSRC_EMAIL_VERIFY,
} from '../constants';
import { globalFetch } from './globalActions';

////////////////////////
// EMAIL VERIFICATION //
////////////////////////

export function clearCheckEmailAddress() {
  return function (dispatch) {
    dispatch({ type: CHECK_EMAIL_SUCCESS, item: {} });
  };
}

export function checkEmailAddress(email) {
  return (dispatch, getState) => {
    // Execute the globalFetch function to get the actual Promise
    const fetchPromise = globalFetch({
      urlSrc: FEED_URLSRC_EMAIL_VERIFY,
      extraParams: `?access_key=${VERIFICATION_ACCESS_KEY}&email=${email}`,
      reducerError: CHECK_EMAIL_HAS_ERRORED,
      dispatchSuccess: (itemObj, dispatch) => {
        dispatch({ type: CHECK_EMAIL_SUCCESS, payload: itemObj });
      },
    })(dispatch, getState);

    let timeoutId;
    const timeoutPromise = new Promise((resolve) => {
      timeoutId = setTimeout(() => {
        resolve('timeout');
      }, 1000);
    });

    // Create cleanup function after promise is initialized
    const cleanup = () => clearTimeout(timeoutId);

    return Promise.race([timeoutPromise, fetchPromise])
      .then((result) => {
        if (result === 'timeout') {
          dispatch({
            type: CHECK_EMAIL_SUCCESS,
            payload: true,
          });
          return Promise.resolve();
        }
        // Clear the timeout if fetch wins
        cleanup();
        return result;
      })
      .catch((error) => {
        console.error('Error in email verification:', error);
        dispatch({ type: CHECK_EMAIL_HAS_ERRORED, payload: true });
      });
  };
}
